/* lk-lp.js — landing-page behaviour (2026-09-17).
   Scroll reveals, the colour stage (auto cross-fade + swatches + keyboard),
   and count-up numbers. Everything degrades to a readable static page:
   the reveal class is only armed once this file runs, so with JS blocked
   nothing is left invisible. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;
  document.documentElement.classList.add('lk-lp-ready');

  function reveal() {
    var els = [].slice.call(document.querySelectorAll('.lk-rv:not([data-rv-bound])'));
    els.forEach(function (el) { el.setAttribute('data-rv-bound', '1'); });
    if (reduced || !IO) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function stage(root) {
    if (root.dataset.bound === '1') return; root.dataset.bound = '1';
    var shots = [].slice.call(root.querySelectorAll('[data-lp-shot]'));
    // root is the shot itself; the picker, heading, button and price all live in the
    // copy column beside it, so everything but the chip is resolved from the section
    var scope = root.closest('.lk-stage') || document;
    var dots = [].slice.call(scope.querySelectorAll('[data-lp-sw]'));
    var name = root.querySelector('[data-lp-name]');
    var swap = scope.querySelector('[data-lp-swap]');
    var link = scope.querySelector('[data-lp-link]');
    var priceEl = scope.querySelector('[data-lp-price]');
    var compareEl = scope.querySelector('[data-lp-compare]');
    var offEl = scope.querySelector('[data-lp-off]');
    var n = shots.length; if (!n) return;
    var i = 0, timer = null, stopped = false;
    var wait = (parseInt(root.dataset.interval, 10) || 2600);

    function draw(k) {
      i = ((k % n) + n) % n;
      shots.forEach(function (s, j) { s.classList.toggle('on', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); d.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      var label = shots[i].getAttribute('data-colour') || '';
      // a block-driven stage swaps the short caption ("Cat-eye") while the chip
      // under the shot carries the full label ("K2904 · Cat-eye")
      var short = shots[i].getAttribute('data-swap') || label;
      if (name) name.textContent = label;
      if (link) link.href = shots[i].getAttribute('data-href') || link.href;
      // a stage of different models carries a price per slide
      var pr = shots[i].getAttribute('data-price');
      if (pr && priceEl) priceEl.textContent = pr;
      if (pr) {
        var cmp = shots[i].getAttribute('data-compare'), off = shots[i].getAttribute('data-off');
        if (compareEl) { compareEl.textContent = cmp || ''; compareEl.hidden = !cmp; }
        if (offEl) { offEl.textContent = off || ''; offEl.hidden = !off; }
      }
      if (swap && swap.textContent !== short) {
        if (reduced) { swap.textContent = short; }
        else { swap.classList.add('is-out'); setTimeout(function () { swap.textContent = short; swap.classList.remove('is-out'); }, 300); }
      }
    }
    function stop() { stopped = true; if (timer) { clearInterval(timer); timer = null; } }
    function play() { if (stopped || reduced || n < 2 || timer) return; timer = setInterval(function () { draw(i + 1); }, wait); }

    dots.forEach(function (d, j) { d.addEventListener('click', function () { stop(); draw(j); }); });
    scope.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault(); stop(); draw(i + (e.key === 'ArrowRight' ? 1 : -1));
    });
    scope.addEventListener('pointerdown', function (e) { if (e.target.closest('[data-lp-sw]')) return; stop(); });
    if (IO) { new IntersectionObserver(function (en) { en[0].isIntersecting ? play() : (timer && (clearInterval(timer), timer = null)); }, { threshold: .3 }).observe(root); }
    else play();
    draw(0);
  }

  function counters() {
    var els = [].slice.call(document.querySelectorAll('[data-count]:not([data-count-bound])'));
    els.forEach(function (el) { el.setAttribute('data-count-bound', '1'); });
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-count')) || 0;
      var pre = el.getAttribute('data-pre') || '', post = el.getAttribute('data-post') || '';
      if (reduced) { el.textContent = pre + Math.round(to).toLocaleString('en-IN') + post; return; }
      var t0 = null, dur = 900;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + Math.round(to * e).toLocaleString('en-IN') + post;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!IO) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: .5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() { reveal(); counters(); document.querySelectorAll('[data-lp-stage]').forEach(stage); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
